import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { getColorVar } from 'src/utils/theme/colorVars';

export type ProgressState = {
	start: number;
	end: number;
	current: number;
	direction: 'end-full' | 'end-empty';
	type: 'neutral' | 'warn' | 'strong-warn';
	size?: number;
};

const ProgressIndicator = (props: ProgressState) => {
	const startEndDelta = props.end - props.start;
	const currentDelta = props.current - props.start;
	let progressValue = Math.min((currentDelta / startEndDelta) * 100, 100);

	if (props.direction === 'end-empty') {
		progressValue = 100 - progressValue;
	}

	const strokeColour =
		props.type === 'neutral'
			? getColorVar('text-default')
			: props.type === 'warn'
				? getColorVar('star-yellow')
				: getColorVar('text-negative-red-button');

	return (
		<div style={{ width: props.size ?? 16, height: props.size ?? 16 }}>
			<CircularProgressbar
				value={progressValue}
				strokeWidth={50}
				styles={buildStyles({
					pathColor: strokeColour,
					trailColor: 'transparent',
					pathTransitionDuration: 0.15,
				})}
			/>
		</div>
	);
};

export default ProgressIndicator;
